import { render, staticRenderFns } from "./VisitaItem.vue?vue&type=template&id=74a3d99d&scoped=true"
import script from "./VisitaItem.vue?vue&type=script&lang=js"
export * from "./VisitaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a3d99d",
  null
  
)

export default component.exports